export const fonts = {
  heading: 'Moderat, sans-serif',
  body: 'Moderat, sans-serif'
}
